const DASHBOARD_COMPONENT = "src/Components/Dashboards/RoleDashboards.jsx";

export const MANAGEMENT_DASHBOARD_HOME = {
  key: "dashboard",
  label: "Dashboard",
  path: "",
  sidebarGroup: "home",
  component: DASHBOARD_COMPONENT,
  mobile: true,
};

const SIDEBAR_GROUPS = [
  {
    key: "studentsHub",
    label: "Students",
    sidebarGroup: "operations",
    childKeys: ["students", "admissions"],
  },
  {
    key: "staffHub",
    label: "Staff",
    sidebarGroup: "operations",
    childKeys: ["teachers", "teacherAllocation", "staffAccess"],
  },
  {
    key: "academicsHub",
    label: "Academics",
    sidebarGroup: "academic",
    childKeys: [
      "coursePlan",
      "homework",
      "zeroPeriod",
      "calendarManager",
      "exams",
      "timetable",
      "academicSetup",
      "classesSetup",
      "sectionsSetup",
      "subjectMaster",
      "classSubjects",
      "timetableSettings",
    ],
  },
  {
    key: "financeHub",
    label: "Finance",
    sidebarGroup: "finance",
    childKeys: ["fees"],
  },
  {
    key: "communicationHub",
    label: "Communication",
    sidebarGroup: "communication",
    childKeys: ["messages"],
  },
  {
    key: "settingsHub",
    label: "Settings",
    sidebarGroup: "settings",
    childKeys: ["managementSetup", "academicYear"],
  },
];

export const MANAGEMENT_ROUTE_REGISTRY = [
  {
    key: "profile",
    label: "My Profile",
    path: "profile",
    sidebarGroup: "settings",
    component: "src/Components/Admin/MyProfile.jsx",
    menu: false,
    mobile: true,
  },
  {
    key: "managementSetup",
    label: "Management Setup",
    path: "management-setup",
    sidebarGroup: "settings",
    component: "src/Components/Admin/Modules/ManagementSetup.jsx",
    mobile: true,
  },
  {
    key: "messages",
    label: "Messages",
    path: "messages",
    sidebarGroup: "communication",
    component: "src/Components/Admin/Modules/MessagingCenter.jsx",
    permissionKey: "messages",
    mobile: true,
  },
  {
    key: "attendance",
    label: "Attendance",
    path: "attendance",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Attendance.jsx",
    permissionKey: "attendance",
    mobile: true,
  },
  {
    key: "academicYear",
    label: "Academic Year",
    path: "academic-year",
    sidebarGroup: "settings",
    component: "src/Components/Admin/Modules/SettingsWorkspace.jsx",
    permissionKey: "managementSetup",
    mobile: true,
  },
  {
    key: "staffAttendance",
    label: "Staff Attendance",
    path: "staff-attendance",
    sidebarGroup: "operations",
    component: "src/Components/Admin/StaffAttendanceRegister.jsx",
    permissionKey: "staffAttendance",
    mobile: true,
  },
  {
    key: "teachers",
    label: "Teachers",
    path: "teachers",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Modules/TeachersSetup.jsx",
    permissionKey: "teachers",
    mobile: true,
  },
  {
    key: "staffAccess",
    label: "Access & Login",
    path: "staff-access",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Modules/StaffAccessLogin.jsx",
    permissionKey: "teachers",
    mobile: true,
  },
  {
    key: "students",
    label: "Students",
    path: "students",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Modules/StudentsSetup.jsx",
    permissionKey: "students",
    mobile: true,
  },
  {
    key: "studentCreate",
    label: "Add Student",
    path: "students/new",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Modules/StudentsSetup.jsx",
    permissionKey: "students",
    mobile: true,
    menu: false,
  },
  {
    key: "admissions",
    label: "Admissions",
    path: "admissions",
    sidebarGroup: "operations",
    component: "src/Components/Admin/Admissions.jsx",
    permissionKey: "students",
    mobile: true,
    menu: false,
  },
  {
    key: "academicSetup",
    label: "Academic Setup",
    path: "academic-setup",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/AcademicSetup.jsx",
    permissionKey: "academicSetup",
    mobile: true,
  },
  {
    key: "calendarManager",
    label: "Calendar",
    path: "calendar",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/CalendarManager.jsx",
    permissionKey: "calendar",
    mobile: true,
  },
  {
    key: "zeroPeriod",
    label: "Daily Test",
    path: "zero-period",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/ZeroPeriodManager.jsx",
    permissionKey: "zeroPeriod",
    mobile: true,
  },
  {
    key: "zeroPeriodTest",
    label: "Zero Period Test",
    path: "zero-period-test",
    sidebarGroup: "academic",
    component: "src/Components/Dashboards/PrincipalDailyTestInsights.jsx",
    permissionKey: "zeroPeriod",
    mobile: true,
  },
  {
    key: "coursePlan",
    label: "Course Plan",
    path: "course-plan",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/CoursePlanManager.jsx",
    permissionKey: "coursePlan",
    mobile: true,
  },
  {
    key: "homework",
    label: "Homework",
    path: "homework",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/ManagementHomework.jsx",
    permissionKey: "homework",
    mobile: true,
  },
  {
    key: "exams",
    label: "Exams & Results",
    path: "exams",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/ExamsResultsManager.jsx",
    permissionKey: "academicSetup",
    mobile: true,
  },
  {
    key: "classesSetup",
    label: "Classes",
    path: "classes",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/ClassesSetup.jsx",
    permissionKey: "academicSetup",
    menu: false,
    mobile: true,
  },
  {
    key: "sectionsSetup",
    label: "Sections",
    path: "sections",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/SectionsSetup.jsx",
    permissionKey: "academicSetup",
    menu: false,
    mobile: true,
  },
  {
    key: "subjectMaster",
    label: "Subject Master",
    path: "subject-master",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/SubjectMaster.jsx",
    permissionKey: "academicSetup",
    menu: false,
    mobile: true,
  },
  {
    key: "classSubjects",
    label: "Class Subjects",
    path: "class-subjects",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/ClassSubjects.jsx",
    permissionKey: "academicSetup",
    menu: false,
    mobile: true,
  },
  {
    key: "teacherAllocation",
    label: "Teacher Allocation",
    path: "teacher-allocation",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/TeacherAllocation.jsx",
    permissionKey: "academicSetup",
    menu: false,
    mobile: true,
  },
  {
    key: "timetable",
    label: "Timetable",
    path: "timetable",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/TimetableGrid.jsx",
    permissionKey: "timetable",
    menu: false,
    mobile: true,
  },
  {
    key: "timetableSettings",
    label: "Timetable Settings",
    path: "timetable-settings",
    sidebarGroup: "academic",
    component: "src/Components/Admin/Modules/TimetableSettings.jsx",
    permissionKey: "timetable",
    menu: false,
    mobile: true,
  },
  {
    key: "fees",
    label: "Accounting",
    path: "fees",
    sidebarGroup: "finance",
    component: "src/Components/Admin/Fees.jsx",
    permissionKey: "fees",
    mobile: true,
  },
  {
    key: "payroll",
    label: "Payroll",
    path: "payroll",
    sidebarGroup: "payroll",
    component: "src/Components/Admin/Payroll.jsx",
    permissionKey: "payroll",
    mobile: true,
  },
  {
    key: "reports",
    label: "Reports",
    path: "reports",
    sidebarGroup: "finance",
    component: "src/Components/Admin/Reports.jsx",
    permissionKey: "reports",
    mobile: true,
  },
];

const MANAGEMENT_CAPABILITY_BY_KEY = Object.freeze({
  managementSetup: ["settings.school", "settings.users"],
  academicYear: "settings.academic_year",
  messages: "communication.parent_inbox.view",
  attendance: "student_attendance.view",
  staffAttendance: "staff_attendance.view",
  teachers: "teachers.view",
  staffAccess: "settings.users",
  students: "students.view",
  studentCreate: "students.add",
  admissions: "students.admissions",
  academicSetup: "academics.view",
  calendarManager: "academics.view",
  zeroPeriod: "academics.view",
  zeroPeriodTest: "academics.view",
  coursePlan: "academics.view",
  homework: "homework.view",
  exams: "academics.view",
  classesSetup: "academics.view",
  sectionsSetup: "academics.view",
  subjectMaster: "academics.view",
  classSubjects: "academics.view",
  teacherAllocation: "teacher_allocation.view",
  timetable: "timetable.view",
  timetableSettings: "timetable.view",
  fees: "finance.view_dues",
  payroll: "payroll.view",
  reports: "reports.finance",
});

const DIRECTOR_MENU_ORDER = [
  "students",
  "teachers",
  "attendance",
  "academicSetup",
  "exams",
  "fees",
  "payroll",
  "messages",
  "reports",
  "managementSetup",
];

const sortMenuForRole = (entries, roleKey) => {
  if (roleKey !== "director") return entries;
  const order = new Map(DIRECTOR_MENU_ORDER.map((key, index) => [key, index]));
  return [...entries].sort(
    (left, right) =>
      (order.get(left.key) ?? 999) - (order.get(right.key) ?? 999),
  );
};

const normalizeRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase();

const buildDashboardRoute = (role) => {
  const roleKey = normalizeRole(role);
  return roleKey ? `/dashboard/${roleKey}` : "/dashboard";
};

export const getManagementRoutesForRole = (role) => {
  normalizeRole(role);
  return MANAGEMENT_ROUTE_REGISTRY;
};

export const getManagementMenuForRole = (role) => {
  const roleKey = normalizeRole(role);
  const dashboardRoute = buildDashboardRoute(roleKey);
  const routeItems = sortMenuForRole(
    getManagementRoutesForRole(roleKey),
    roleKey,
  ).map((entry) => ({
    key: entry.key,
    label: entry.label,
    mobile: entry.mobile !== false,
    menu: false,
    route: `${dashboardRoute}/${entry.path}`,
    sidebarGroup: entry.sidebarGroup,
    component: entry.component,
    permissionKey: entry.permissionKey,
    capabilityKey: MANAGEMENT_CAPABILITY_BY_KEY[entry.key] || null,
  }));
  const routeItemByKey = new Map(routeItems.map((entry) => [entry.key, entry]));
  const buildSidebarGroup = (group) => {
    const childKeys =
      group.key === "staffHub" && roleKey === "director"
        ? [...group.childKeys, "staffAttendance"]
        : group.childKeys;
    const children = childKeys
      .map((key) => routeItemByKey.get(key))
      .filter(Boolean);
    if (!children.length) return null;
    const defaultChild = children[0];
    return {
      key: group.key,
      label: group.label,
      mobile: true,
      menu: true,
      route: defaultChild.route,
      sidebarGroup: group.sidebarGroup,
      defaultChildKey: defaultChild.key,
      activeKeys: children.map((child) => child.key),
      children,
      permissionKey: defaultChild.permissionKey,
    };
  };
  const groupedItems = SIDEBAR_GROUPS.map(buildSidebarGroup).filter(Boolean);
  const groupByKey = new Map(groupedItems.map((entry) => [entry.key, entry]));
  const attendanceItem = routeItemByKey.get("attendance")
    ? { ...routeItemByKey.get("attendance"), menu: true }
    : null;
  const staffAttendanceItem =
    roleKey !== "director" && routeItemByKey.get("staffAttendance")
      ? { ...routeItemByKey.get("staffAttendance"), menu: true }
      : null;
  const reportsItem = routeItemByKey.get("reports")
    ? { ...routeItemByKey.get("reports"), menu: true }
    : null;
  const payrollItem = routeItemByKey.get("payroll")
    ? { ...routeItemByKey.get("payroll"), menu: true }
    : null;
  const sidebarItems = [
    groupByKey.get("studentsHub"),
    groupByKey.get("staffHub"),
    attendanceItem,
    staffAttendanceItem,
    groupByKey.get("academicsHub"),
    groupByKey.get("financeHub"),
    payrollItem,
    groupByKey.get("communicationHub"),
    reportsItem,
    groupByKey.get("settingsHub"),
  ].filter(Boolean);
  return [
    {
      ...MANAGEMENT_DASHBOARD_HOME,
      route: dashboardRoute,
    },
    ...sidebarItems,
    ...routeItems,
  ];
};

export const getManagementRouteEntriesForRole = (role) => {
  const roleKey = normalizeRole(role);
  const dashboardRoute = buildDashboardRoute(roleKey);
  return sortMenuForRole(getManagementRoutesForRole(roleKey), roleKey).map(
    (entry) => ({
      ...entry,
      route: `${dashboardRoute}/${entry.path}`,
    }),
  );
};

export const getManagementModuleMeta = (role, key) =>
  getManagementMenuForRole(role).find((entry) => entry.key === key) || null;

export const getManagementModulePath = (role, key) =>
  getManagementModuleMeta(role, key)?.route || "";
